/* TTG Anlass-Seite Muttertag „Ein Tag mit Hundemama“ (21.10.2026, Briefing anlass-main-2026-10-21).
   1. Zeitleiste: misst ihre Höhe (--ttg-mt-leiste-h für scroll-margin-top), blendet Punkte ohne Ziel aus und springt mit
      Abstand unter Leiste und – beim Hochspringen – eingeblendetem Theme-Header.
   2. Aktive Stunde: die letzte Stunde, deren Oberkante die Leiste erreicht hat, wird hervorgehoben (is-aktiv,
      aria-current). Am Handy (Leiste wischt seitlich) rollt die Leiste den aktiven Punkt selbst ins Bild.
   Wird von mehreren Sections eingebunden (defer) und läuft trotzdem nur einmal. */
(() => {
  if (window.__ttgMuttertag) return;
  window.__ttgMuttertag = true;

  const bewegung = () => !window.matchMedia || window.matchMedia('(prefers-reduced-motion: no-preference)').matches;
  const leiste = () => document.querySelector('[data-ttg-mt-leiste]');

  const headerHoehe = () => {
    const h = document.querySelector('#header-component');
    if (!h || !h.getAttribute('sticky')) return 0;
    const v = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height'));
    return Number.isFinite(v) && v > 0 ? v : h.getBoundingClientRect().height;
  };

  const hoeheSetzen = () => {
    const l = leiste();
    if (l) document.documentElement.style.setProperty('--ttg-mt-leiste-h', `${Math.round(l.getBoundingClientRect().height)}px`);
  };

  let punkte = [];
  const punkteLesen = () => {
    const l = leiste();
    if (!l) { punkte = []; return; }
    punkte = [...l.querySelectorAll('.ttg-mt-leiste__punkt')].map((li) => {
      const a = li.querySelector('a[href^="#"]');
      const id = a ? decodeURIComponent(a.getAttribute('href').slice(1)) : '';
      const ziel = id ? document.getElementById(id) : null;
      li.hidden = !ziel;
      return { li, a, ziel };
    }).filter((p) => p.ziel);
  };

  /* ---------- 1 Sprung ---------- */
  document.addEventListener('click', (e) => {
    const a = e.target.closest('.ttg-mt a[href^="#"]');
    if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const id = decodeURIComponent(a.getAttribute('href').slice(1));
    const ziel = id && document.getElementById(id);
    if (!ziel) return;
    e.preventDefault();
    const l = leiste();
    const lh = l ? l.getBoundingClientRect().height : 0;
    const y = ziel.getBoundingClientRect().top + window.scrollY;
    const hoch = y < window.scrollY;
    window.scrollTo({ top: Math.max(0, Math.round(y - lh - (hoch ? headerHoehe() : 0))), behavior: bewegung() ? 'smooth' : 'auto' });
    try { history.replaceState(null, '', `#${id}`); } catch (err) { /* ohne History bleibt der Sprung */ }
    if (!ziel.hasAttribute('tabindex')) ziel.setAttribute('tabindex', '-1');
    ziel.focus({ preventScroll: true });
  });

  /* ---------- 2 Aktive Stunde ---------- */
  let aktiv = null;
  let geplant = false;

  const insBild = (li) => {
    const ol = li.parentElement;
    if (!ol || ol.scrollWidth <= ol.clientWidth + 1) return;
    const links = li.offsetLeft - (ol.clientWidth - li.offsetWidth) / 2;
    ol.scrollTo({ left: Math.max(0, links), behavior: bewegung() ? 'smooth' : 'auto' });
  };

  const aktivSetzen = () => {
    geplant = false;
    if (!punkte.length) return;
    const l = leiste();
    const kante = (l ? l.getBoundingClientRect().bottom : 0) + 24;
    let neu = punkte[0];
    for (const p of punkte) if (p.ziel.getBoundingClientRect().top <= kante) neu = p;
    if (neu === aktiv) return;
    if (aktiv) { aktiv.li.classList.remove('is-aktiv'); aktiv.a.removeAttribute('aria-current'); }
    punkte.forEach((p) => { if (p !== neu) { p.li.classList.remove('is-aktiv'); p.a.removeAttribute('aria-current'); } });
    neu.li.classList.add('is-aktiv');
    neu.a.setAttribute('aria-current', 'true');
    aktiv = neu;
    insBild(neu.li);
  };
  const planen = () => { if (!geplant) { geplant = true; requestAnimationFrame(aktivSetzen); } };

  const start = () => {
    hoeheSetzen();
    punkteLesen();
    const l = leiste();
    if (l && window.ResizeObserver) new ResizeObserver(hoeheSetzen).observe(l);
    aktivSetzen();
    window.addEventListener('scroll', planen, { passive: true });
    window.addEventListener('resize', planen);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
